// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import { IconPositioner } from "@steiner/MobiusOverrides/AccordionSection/AccordionSection";
import { specificationsStyles } from "@steiner/Overrides/Widgets/ProductDetails/ProductDetailsSpecifications";
import PlayCircle from "@steiner/XDL/Icons/PlayCircle";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color } from "@steiner/XDL/Utilities";
import { avoidBreakInsidePrintElement, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

specificationsStyles.container = {
    css: css`
        margin: 26px 0 48px;
        ${avoidBreakInsidePrintElement}

        ${xScreen("lte", "md")} {
            margin-top: 0;
        }
    `,
};

specificationsStyles.specificationsAccordion = {
    headingLevel: 2,
    css: css`
        dd {
            padding: 12px 0 0;
            border: 0;
        }
        > div {
            margin-bottom: 8px;
            &:not(.attributesAccordion) {
                dd {
                    padding-left: 10px;
                }
            }
        }
    `,
};

specificationsStyles.documentsContainer = {
    gap: 25,
    css: css`
        padding: 20px;
        ${xScreen("lte", "md")} {
            padding: 20px 0;
        }
    `,
};

specificationsStyles.documentGridItem = {
    width: [12, 12, 3, 3, 3],
};

specificationsStyles.attributeTypeLabelText = {
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.bold,
    },
    css: css`
        width: 1px; // Allows content to define width
        ${xScreen("lte", "sm")} {
            white-space: break-spaces;
            width: 50%;
        }
    `,
};
specificationsStyles.attributeTypeValuesText = {
    typographyProps: {
        size: 14,
        css: css`
            white-space: break-spaces;
            ${xScreen("lte", "sm")} {
                width: 50%;
            }
        `,
    },
};

specificationsStyles.documentLink = {
    icon: {
        iconProps: {
            src: File,
        },
    },
    typographyProps: {
        size: 14,
    },
    css: css`
        align-items: flex-start;
    `,
};

specificationsStyles.attributeTypeContent = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 10px;
    `,
};

specificationsStyles.documentsTypeContent = {
    css: css`
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 10px;
    `,
};

specificationsStyles.videosWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 10px;
    `,
};

specificationsStyles.videoLink = {
    icon: {
        iconProps: {
            src: PlayCircle,
        },
    },
    typographyProps: {
        size: 14,
    },
};

specificationsStyles.homeAccordionStyles = {
    accordionSection: {
        headerProps: {
            css: css`

                @media print {
                    background: ${color("common.white")};
                    border: 1px solid ${color("common.ui6")};
                    padding: 0;
                    
                    button {
                        background: ${color("common.white")};
                        padding: 6px 12px;
                    }
                }

                ${IconPositioner} {
                    @media print {
                        display: block;
                        color: ${color("text.main")};

                        ${IconWrapper} {
                            color: ${color("text.main")};
                        }
                    }
                }
            }
        `,
        },
        panelProps: {
            css: css`
            @media print {
               &&& {
                display: block;
                padding: 0;
                border: 1px solid ${color("common.ui6")};
               }
            }
        `,
        },
    },
    headingAccordion: {
        title: {
            variant: "h3",
            color: "common.white",
            css: css`
                margin-bottom: 0;
                @media print {
                    color: ${color("text.main")};
                    font-weight: ${fontConfig.weight.regular};
                    font-size: ${fontConfig.fontSize.regular}px;
                    text-decoration: underline;
                }
            `,
        },
    }
};

specificationsStyles.dataTableRow = {
    css: css`
        @media print {
            &&& {
                background: ${color("common.white")};

                td:first-child {
                    width: 25%;
                }
            }
        }
    `,
};